import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** saves the account list in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts
*/
export const SAVE_ACCOUNTS_LIST = (state, payload) => {
    const parsedAccounts = parseAccountsForFeature(payload.bankAccountView).map(account => {
        return {
            ...account,
            isVisible: account.visible
        }
    })

    state.accountsTypesList = payload.bankAccountTypeView

    state.accountsList = parsedAccounts
}

/** saves Accounts List changing the isVisible
@payload { Object } with:
    accountVisibility { Object } - object with id account number of selected switch and it's statement (true or false)
*/
export const SAVES_NEW_ACCOUNT_VISIBILITY = (state, payload) => {
    const firstPayloadKey = Object.keys(payload.accountVisibility)[0]

    state.accountsList = state.accountsList.map(account => {
        return {
            ...account,
            isVisible: account.id.toString() === firstPayloadKey ? payload.accountVisibility[account.id] : account.isVisible
        }
    })
}
